import PropTypes from 'prop-types';
import { intlMessageShape } from './intlMessageShape';
export const DATA_TYPE_OBJECT = 'object';
export const DATA_TYPE_STRING = 'string';
export const DATA_TYPE_NUMBER = 'number';
export const DATA_TYPE_DATE_TIME = 'date-time';
export const dataTypeShape = PropTypes.oneOf([DATA_TYPE_OBJECT, DATA_TYPE_STRING]);
export const dataTypeShapeWithNumber = PropTypes.oneOf([DATA_TYPE_OBJECT, DATA_TYPE_STRING, DATA_TYPE_NUMBER]);
export const dataTypeShapeWithDateTime = PropTypes.oneOf([DATA_TYPE_OBJECT, DATA_TYPE_STRING, DATA_TYPE_DATE_TIME]);
export const availableValuesIdDisplayNameObject = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  displayName: intlMessageShape,
  subtitle: intlMessageShape,
  secondaryLabel: intlMessageShape
};
export const availableValuesCodeNameObject = {
  code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: intlMessageShape,
  subtitle: intlMessageShape,
  secondaryLabel: intlMessageShape
};
export const availableValueObjectShape = PropTypes.oneOfType([PropTypes.shape(availableValuesCodeNameObject), PropTypes.shape(availableValuesIdDisplayNameObject)]);
export const defaultAvailableValuePropType = PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number, availableValueObjectShape]);